import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const UpdateMeterCategoryForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: '',
        public_id: '',
    })
    const {name, public_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {meter_category} = location.state
            setFormData({
                public_id: meter_category.public_id,
                name: meter_category.name,
            })
        }

    }, [location])

    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const meter_categoryData = {name}
        updateMeterCategory(public_id, meter_categoryData)
    }

    //update meter_category
    const updateMeterCategory = async (public_id, meter_categoryData) => {
        try {
            setIsLoading(true)
            const response = await Server.put(`/meter-categories/${public_id}`, meter_categoryData)
            if(response.status === 200){
                toast.success('Successfully updated')
                navigate('/meter-categories')
                setIsLoading(false)
            }else{
                setIsLoading(false)
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Meter Category</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputField
                                placeholder="Meter Category Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Meter Category" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UpdateMeterCategoryForm
